import { useContext } from "react"
import { ChatContext } from "../providers/chat-provider"

const UseChat = () => {
    const chatData = useContext(ChatContext)

    return chatData
}

export default UseChat